import React from "react";
import { InputNumber, DatePicker, Radio, Checkbox, Select } from "antd";
import moment from "moment";
import "../styles/socialSecurity.css";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
const { Option } = Select;
export const SocialSecurityHardCodeFields = ({
  formFields,
  formData,
  onChange,
}) => {
  return (
    <div className="social-security-calculator-content-form">
      {formFields &&
        formFields.map((field) => {
          const value = formData ? formData[field.name] : null;
          return (
            <div
              className="social-security-calculator-form-field"
              key={field.name}
            >
              <label
                className="social-security-calculator-form-label"
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  columnGap: "3px",
                }}
              >
                {field.label} <ToolTipCreator name={field.tooltip} />
              </label>
              {field.type === "number" ? (
                <div
                  className="social-security-inputWrapper"
                  style={{ display: "flex" }}
                >
                  {!field.name.includes("%") && (
                    <span className="dollarSymbol">$</span>
                  )}
                  <InputNumber
                    className="social-security-calculator-input"
                    placeholder={`${field.label}`}
                    value={value}
                    step={1}
                    formatter={(value) =>
                      value
                        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : ""
                    }
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "Tab",
                        "Escape",
                        "Enter",
                        "ArrowLeft",
                        "ArrowRight",
                        "Home",
                        "End",
                      ];
                      if (allowedKeys.includes(e.key)) return;

                      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                      if (e.ctrlKey || e.metaKey) return;

                      // Block everything except digits and one minus at start
                      if (!/[0-9]/.test(e.key)) {
                        if (
                          e.key === "-" &&
                          e.target.selectionStart === 0 &&
                          !e.target.value.includes("-")
                        ) {
                          return; // allow minus only at the very beginning
                        }
                        e.preventDefault();
                      }
                    }}
                    min={-999999999999} // very large negative
                    max={999999999999}
                    onChange={(val) => onChange(field.name, val)}
                    parser={(value) => value.replace(/,/g, "")}
                    style={{ width: "100%" }}
                  />
                  {field.name.includes("%") && (
                    <span className="dollarSymbol">%</span>
                  )}
                </div>
              ) : field.type === "date" ? (
                <div
                  className="social-security-inputWrapper"
                  style={{ display: "flex" }}
                >
                  <DatePicker
                    className="social-security-calculator-input"
                    style={{
                      width: "100%",
                      border: "1px solid #d1d5db",
                      borderRadius: "4px",
                    }}
                    format={"MM/DD/YYYY"}
                    value={value ? moment(value) : null}
                    onChange={(date) =>
                      onChange(
                        field.name,
                        date ? date.format("MM/DD/YYYY") : null
                      )
                    }
                    placeholder={`Select ${field.label}`}
                  />
                </div>
              ) : field.type === "radio" ? (
                /* Radio Buttons */
                <Radio.Group
                  value={value}
                  onChange={(e) => onChange(field.name, e.target.value)}
                  optionType="button"
                  buttonStyle="solid"
                  size="large"
                >
                  {field.options &&
                    field.options.map((item) => (
                      <Radio.Button
                        value={item.value}
                        style={{ marginRight: "0.5rem" }}
                      >
                        {item.label}
                      </Radio.Button>
                    ))}
                </Radio.Group>
              ) : field.type === "checkbox" ? (
                /* Checkboxes */
                <Checkbox.Group
                  value={value}
                  options={field.options && field.options}
                  onChange={(val) => onChange(field.name, val)}
                  style={{ display: "flex", flexDirection: "column" }}
                />
              ) : field.type === "select" ? (
                <Select
                  placeholder={`Select ${field.label}`}
                  style={{ width: "100%" }}
                  value={value}
                  onChange={(val) => onChange(field.name, val)}
                  allowClear
                >
                  {field.options &&
                    field.options &&
                    field.options.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                </Select>
              ) : null}
            </div>
          );
        })}
      {/* 🔹 Dynamic Child DOB Fields */}
      {formData &&
        formData.numDependents &&
        formData.numDependents > 0 &&
        Array.from({ length: formData.numDependents }).map((_, idx) => {
          const childKey = `childDob${idx + 1}`;
          return (
            <div key={childKey} className="social-security-inputWrapper">
              <label className="social-security-calculator-form-label">
                Child {idx + 1} Date of Birth
              </label>
              <DatePicker
                className="social-security-calculator-input"
                style={{
                  width: "100%",
                  border: "1px solid #d1d5db",
                  borderRadius: "4px",
                }}
                format={"MM/DD/YYYY"}
                value={formData[childKey] ? moment(formData[childKey]) : null}
                onChange={(date) =>
                  onChange(childKey, date ? date.format("MM/DD/YYYY") : null)
                }
                placeholder={`Select Child ${idx + 1} DOB`}
              />
            </div>
          );
        })}
    </div>
  );
};
